export enum RELATED_COMPANY_TYPE {
  EMPLOYER = 'EMPLOYER',
  SELF_EMPLOYMENT_BUSINESS = 'SELF_EMPLOYMENT_BUSINESS',
}

export enum TRUST_TYPE {
  CASH_MANAGEMENT_TRUST = 'CASH_MANAGEMENT_TRUST',
  DISCRETIONARY_TRUST = 'DISCRETIONARY_TRUST',
  FIXED = 'FIXED',
  HYBRID = 'HYBRID',
  SIMPLE_OR_BARE = 'SIMPLE_OR_BARE',
  SUPERANNUATION_TRUSTS = 'SUPERANNUATION_TRUSTS',
  UNIT = 'UNIT',
  OTHER = 'OTHER',
}
